import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./registerServiceWorker"; // ✅ garde uniquement cette ligne
import "./css/styles2.css";
import StoragePlugin from "vue-web-storage";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const app = createApp(App)
  .use(router)
  .use(store)
  .use(StoragePlugin, {
    prefix: "sess_",
    drivers: ["session", "local"]
  });

app.config.globalProperties.$swal = Swal;
app.mount("#app");
